import ContactUsView from "../components/Sections/ContactUsView";

export default function ContactUs() {
    return (<ContactUsView />);
}